<template>
  <a-form :form="form">
    <a-form-item v-if="showTime" label="发送间隔(秒)" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-input-number v-decorator="['timeout', { initialValue: 5 }]" />
    </a-form-item>
    <a-form-item label="消息类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-select
        style="width: 270px"
        v-decorator="['type', { initialValue: 1, rules: [{ required: true, message: '必填项' }] }]"
      >
        <a-select-option v-for="item in messageTypes" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
      </a-select>
      <a-icon v-show="form.getFieldValue('type') === 8" type="question-circle" :style="{color:'#1890ff', marginLeft: '10px'}" @click="questionShowModal" />
    </a-form-item>

    <div v-if="form.getFieldValue('type') === 2">
      <a-form-item label="回复图片消息" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-upload
          action="https://upload-z2.qiniup.com"
          listType="picture"
          class="upload-list-inline"
          :data="{ token: UploadToken }"
          :beforeUpload="beforeUpload"
          v-decorator="[
            'tupian',
            {
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
        >
          <a-button v-if="!form.getFieldValue('tupian') || form.getFieldValue('tupian').length < 1">
            <a-icon type="upload" />上传
          </a-button>
        </a-upload>
      </a-form-item>
    </div>
    <div v-else-if="form.getFieldValue('type') === 3">
      <a-form-item label="回复视频消息" :labelCol="labelCol" :wrapperCol="wrapperCol" help="文件大小不得超过5M">
        <a-upload
          action="https://upload-z2.qiniup.com"
          listType="text"
          class="upload-list-inline"
          :data="{ token: UploadToken }"
          :beforeUpload="beforeUpload"
          v-decorator="[
            'shipin',
            {
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
        >
          <a-button v-if="!formData['shipin'] || formData['shipin'].length < 1">
            <a-icon type="upload" />上传
          </a-button>
        </a-upload>
      </a-form-item>
    </div>
    <div v-else-if="form.getFieldValue('type') === 4">
      <a-form-item label="回复动图消息" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-upload
          action="https://upload-z2.qiniup.com"
          listType="text"
          class="upload-list-inline"
          :data="{ token: UploadToken }"
          :beforeUpload="beforeUpload"
          v-decorator="[
            'dongtu',
            {
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
        >
          <a-button v-if="!formData['dongtu'] || formData['dongtu'].length < 1">
            <a-icon type="upload" />上传
          </a-button>
        </a-upload>
      </a-form-item>
    </div>
    <div v-else-if="form.getFieldValue('type') === 5">
      <a-form-item label="卡片标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入" :rows="2" v-decorator="['kapianTitle']" />
      </a-form-item>
      <a-form-item label="卡片描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入" :rows="2" v-decorator="['kapianDesc']" />
      </a-form-item>
      <a-form-item label="卡片图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入" :rows="2" v-decorator="['kapianImg']" />
      </a-form-item>
      <a-form-item label="卡片链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入" :rows="2" v-decorator="['kapianUrl']" />
      </a-form-item>
    </div>
    <div v-else-if="form.getFieldValue('type') === 6">
      <a-form-item label="群ID" :labelCol="labelCol" :wrapperCol="wrapperCol" extra="示例：112255442@chatroom">
        <a-input placeholder="请输入" :rows="2" v-decorator="['qunId']" />
      </a-form-item>
    </div>
    <div v-else-if="form.getFieldValue('type') === 7">
      <a-form-item
        label="wxid或公众号id"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        extra="wxid或者公众号的原始id"
      >
        <a-input placeholder="请输入" :rows="2" v-decorator="['wid']" />
      </a-form-item>
    </div>
    <div v-else-if="form.getFieldValue('type') === 8">
      <a-form-item label="消息数据" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea placeholder="请输入" :rows="2" v-decorator="['content']" />
      </a-form-item>
    </div>
    <div v-else>
      <a-form-item label="回复文本消息" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea placeholder="请输入" :rows="2" v-decorator="['wenben']" />
      </a-form-item>
    </div>
  </a-form>
</template>
<script>

import ProgramApi from '@/api/program'

const messageTypes = [
  { value: 1, label: '文本' },
  { value: 2, label: '图片' },
  { value: 3, label: '视频' },
  { value: 4, label: '动图' },
  { value: 5, label: '卡片' },
  { value: 6, label: '群邀请' },
  { value: 7, label: '名片' }
  // { value: 8, label: '小程序/视频号' }
]

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      messageTypes,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      formData: {},
      UploadToken: ''
    }
  },
  created() {
  },
  props: {
    showTime: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    async validate() {
      return new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          if (err) {
            reject(err)
          } else {
            resolve({
              ...values,
              content: this.validateMessage(values)
            })
          }
        })
      })
    },
    validateMessage(values) {
      const { type } = values
      if (type === 1) {
        return values.wenben
      } else if (type === 2) {
        if (!values.tupian[0]) {
          return ''
        }
        return values.tupian[0].response
      } else if (type === 3) {
        if (!values.shipin[0]) {
          return ''
        }
        return values.shipin[0].response
      } else if (type === 4) {
        if (!values.dongtu[0]) {
          return ''
        }
        return values.dongtu[0].response
      } else if (type === 5) {
        return {
          title: values.kapianTitle,
          des: values.kapianDesc,
          img: values.kapianImg,
          url: values.kapianUrl
        }
      } else if (type === 6) {
        return {
          qunId: values.qunId
        }
      } else if (type === 7) {
        return values.wid
      } else if (type === 8) {
        return values.content
      }
    },
    questionShowModal () {
      const h = this.$createElement
      this.$info({
        title: '智能问答小程序教程',
        content: h('div', {}, [
          h('p', '添加小程序和视频号都是这样操作哦~'),
          h('video', {
            style: {
              width: '300px',
              cursor: 'pointer'
            },
            attrs: {
              autoPlay: true,
              src: 'https://nianchu-chajian.oss-cn-beijing.aliyuncs.com/%E6%99%BA%E8%83%BD%E9%97%AE%E7%AD%94%E5%B0%8F%E7%A8%8B%E5%BA%8F%E6%95%99%E7%A8%8B.mp4'
            },
            on: {
              click: () => {
                window.open('https://nianchu-chajian.oss-cn-beijing.aliyuncs.com/%E6%99%BA%E8%83%BD%E9%97%AE%E7%AD%94%E5%B0%8F%E7%A8%8B%E5%BA%8F%E6%95%99%E7%A8%8B.mp4', '_blank')
              }
            }
          })
        ])
      })
    },
    /**
     * 效验数组
     * @param e
     * @returns {*}
     */
    normFile(e) {
      if (Array.isArray(e)) {
        return e
      }
      return e && e.fileList
    },
    /**
     * 上传图片
     * @param file
     * @returns {Promise<unknown>}
     */
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isLt25M = file.size / 1024 / 1024 < 25
        if (!isLt25M) {
          this.$message.error('由于微信限制，上传文件不能大于25M!')
          reject()
        }
        ProgramApi.getQiniuToken()
          .then((response) => {
            if (response.code === 1) {
              const token = response.data
              this.UploadToken = token
              setTimeout(() => {
                resolve()
              }, 100)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}
</script>
